import { combineReducers } from "redux";
import {
  CREATE_ARTICLES,
  CREATE_ARTICLES_FAILED,
  CREATE_ARTICLES_SUCCESS,
  GET_ARTICLES,
  GET_ARTICLES_FAILED,
  GET_ARTICLES_RESET,
  GET_ARTICLES_SUCCESS,
  GET_DETAIL_ARTICLES,
  GET_DETAIL_ARTICLES_FAILED,
  GET_DETAIL_ARTICLES_RESET,
  GET_DETAIL_ARTICLES_SUCCESS,
  UPDATE_ARTICLES,
  UPDATE_ARTICLES_FAILED,
  UPDATE_ARTICLES_SUCCESS,
  UPDATE_STATUS_ARTICLES,
  UPDATE_STATUS_ARTICLES_FAILED,
  UPDATE_STATUS_ARTICLES_SUCCESS,
} from "store/actions/articles";

const initialState = {
  isLoading: false,
  data: [],
  page: 1,
  total_items: 0,
  total_page: 1,
};

/**
 * auth reducer
 * @param {object} state
 * @param {object} action
 * @returns
 */
function listArticles(state = initialState, action) {
  switch (action.type) {
    case GET_ARTICLES:
      return {
        ...state,
        isLoading: true,
      };
    case GET_ARTICLES_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };

    case GET_ARTICLES_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    case GET_ARTICLES_RESET:
      return initialState;
    default:
      return state;
  }
}

/**
 * update status
 * @param {object} state
 * @param {object} action
 * @returns
 */
function updateStatus(state = initialState, action) {
  switch (action.type) {
    case UPDATE_STATUS_ARTICLES:
      return {
        ...state,
        isLoading: true,
      };
    case UPDATE_STATUS_ARTICLES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };

    case UPDATE_STATUS_ARTICLES_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}

function createArticles(state = initialState, action) {
  switch (action.type) {
    case CREATE_ARTICLES:
      return {
        ...state,
        isLoading: true,
      };
    case CREATE_ARTICLES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };

    case CREATE_ARTICLES_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}

function updateArticles(state = initialState, action) {
  switch (action.type) {
    case UPDATE_ARTICLES:
      return {
        ...state,
        isLoading: true,
      };
    case UPDATE_ARTICLES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };

    case UPDATE_ARTICLES_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}

// detail
function detailArticles(state = initialState, action) {
  switch (action.type) {
    case GET_DETAIL_ARTICLES:
      return {
        ...state,
        isLoading: true,
      };
    case GET_DETAIL_ARTICLES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };

    case GET_DETAIL_ARTICLES_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    case GET_DETAIL_ARTICLES_RESET:
      return initialState;
    default:
      return state;
  }
}

export default combineReducers({
  listArticles,
  updateStatus,
  updateArticles,
  createArticles,
  detailArticles,
});
